import { render, staticRenderFns } from "./feature_product.vue?vue&type=template&id=5e008cab&"
var script = {}
import style0 from "./feature_product.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports